@if (showPanel$ | async) {
  <div class="sidebar-group mat-elevation-z1">
    <mat-icon>star</mat-icon>
    <span transloco="FAVORITES"></span>
    <span class="spacer"></span>
    <app-navigation-expansion-button
      [isExpanded]="(isExpanded$ | async)!"
      (isExpandedChange)="onExpandChanged()"
    ></app-navigation-expansion-button>
  </div>
  @if (isSearchesLoading$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (isExpanded$ | async) {
    <div id="favorite-search-items">
      @for (search of favoriteSearches$ | async; track search) {
        <app-navigation-favorite-search
          [databaseId]="database.id"
          [search]="search"
        ></app-navigation-favorite-search>
      }
    </div>
  }
}
